// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_Option from "../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CustomerOrderApiModel from "../api-model/CustomerOrderApiModel.bs.js";

function decodeApiModel(json) {
  var data = json.result;
  var decodeHistory = function (data) {
    return List.map((function (e) {
                  return {
                          order_id: e.order_id,
                          order_date: Timestamp$Catalyst.make(e.order_date),
                          order_time: Timestamp$Catalyst.make(e.order_time),
                          status: e.status,
                          vehicle: {
                            vehicle_type: Belt_Option.getWithDefault(e.vehicle.vehicle_type, "Not Applicable"),
                            registration_number: Belt_Option.getWithDefault(e.vehicle.registration_number, "Not Applicable")
                          },
                          partner: {
                            name: Belt_Option.getWithDefault(e.partner.name, "Not Applicable"),
                            mobile: Belt_Option.getWithDefault(e.partner.mobile, "Not Applicable")
                          }
                        };
                }), data);
  };
  return {
          last_date_timestamp: Belt_Option.getWithDefault(data.last_date_timestamp, 0.0),
          orders: decodeHistory(data.order)
        };
}

function execute(json) {
  return decodeApiModel(DeccoUtils$Catalyst.resolveResult(CustomerOrderApiModel.t_decode(json), "CustomerOrderEntityMapper.re"));
}

export {
  decodeApiModel ,
  execute ,
  
}
/* Timestamp-Catalyst Not a pure module */
